
import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import ContactForm from '@/components/ContactForm';
import { useLanguage } from '@/contexts/LanguageContext';
import { translations } from '@/utils/translations';
import { updateMetaTags, getCanonicalUrl } from '@/utils/seoUtils';

const ContactPage = () => {
  const { currentLanguage } = useLanguage();
  const { lang } = useParams<{ lang: string }>();
  const t = translations[currentLanguage];
  
  useEffect(() => {
    // Update SEO meta tags
    updateMetaTags({
      title: `${t.contact} | Future Level`,
      description: t.pageDescription || 'Kontaktieren Sie Future Level für professionelle KI-Videomarketing Lösungen. Wir helfen Ihnen gerne weiter.',
      keywords: "Kontakt, Anfrage, Future Level, KI Video Agentur, Video Marketing Kontakt, Videoberatung",
      canonicalUrl: getCanonicalUrl(currentLanguage === 'de' ? 'kontakt' : 
                                   currentLanguage === 'en' ? 'contact' : 
                                   currentLanguage === 'fr' ? 'contact' : 'contatto', 
                                   currentLanguage),
      language: currentLanguage
    });
  }, [currentLanguage, t]);

  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      <main className="flex-grow pt-16 md:pt-20"> {/* Added top padding to account for fixed header */}
        <div className="relative w-full overflow-hidden">
          {/* Replace video background with gradient background */}
          <div className="absolute inset-0 z-0 bg-gradient-to-br from-[#0B0B0B] to-[#1A1F2C]">
            {/* Neural network pattern overlay */}
            <div className="absolute inset-0 bg-[url('/images/grid-pattern.svg')] opacity-10"></div>
            
            {/* Subtle animated elements */}
            <div className="absolute top-0 right-0 w-1/3 h-1/3 bg-purple-900/10 blur-3xl"></div>
            <div className="absolute bottom-0 left-0 w-1/4 h-1/4 bg-purple-800/5 blur-2xl"></div>
          </div>
          
          <div className="container mx-auto px-4 py-0 relative z-10">
            <div className="text-center mb-6 animate-fade-in">
              <h1 className="text-4xl md:text-5xl font-bold mb-4 text-white glow-effect">
                {t.contact}
              </h1>
              <p className="text-lg text-gray-200 max-w-3xl mx-auto">
                Bereit, Ihre Video-Marketingstrategie mit KI zu revolutionieren? Füllen Sie unser Kontaktformular aus – wir melden uns innerhalb von 24 Stunden.
              </p>
            </div>
            
            <div className="max-w-4xl mx-auto backdrop-blur-sm bg-black/40 p-8 rounded-xl border border-purple-500/30">
              <ContactForm />
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default ContactPage;
